import { cloneEffectInstance, type AlterlyEffectInstance } from "./effectRegistry";

export function removeEffect(effects: AlterlyEffectInstance[], instanceId: string) {
  return effects.filter((effect) => effect.instanceId !== instanceId);
}

export function duplicateEffect(effects: AlterlyEffectInstance[], instanceId: string) {
  const index = effects.findIndex((effect) => effect.instanceId === instanceId);
  if (index < 0) return effects;
  const copy = cloneEffectInstance(effects[index]!);
  return [...effects.slice(0, index + 1), copy, ...effects.slice(index + 1)];
}

export function moveEffect(effects: AlterlyEffectInstance[], instanceId: string, direction: -1 | 1) {
  const from = effects.findIndex((effect) => effect.instanceId === instanceId);
  if (from < 0) return effects;
  const to = from + direction;
  if (to < 0 || to >= effects.length) return effects;

  const next = [...effects];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item!);
  return next;
}

export function setEffectOpacity(effects: AlterlyEffectInstance[], instanceId: string, opacity: number) {
  const safeOpacity = Math.max(0, Math.min(1, opacity));
  return effects.map((effect) => effect.instanceId === instanceId ? { ...effect, opacity: safeOpacity } : effect);
}
